import { IMessage } from '../deepseek/atom'
import Message from './Message'
import { useScrollMessageListToBottom } from '../deepseek/hooks'
import { useEffect } from 'react'
import classNames from 'classnames'

interface Props {
  messages: IMessage[]
  className?: string
}

export function MessageList({ messages, className }: Props) {
  const scrollMessageListToBottom = useScrollMessageListToBottom()

  useEffect(() => {
    setTimeout(() => {
      scrollMessageListToBottom(true)
    })
  }, [messages.length])

  return (
    <div className={classNames(className)}>
      <div className=" relative ">
        {messages.map((it, index) => {
          return <Message msg={it} key={it.id} />
        })}

        <div className="h-[46px]"></div>
      </div>
    </div>
  )
}
